import { FC, useRef } from 'react'
import * as styles from 'components/atoms/inputs/DatePicker/Calendar/Calendar.styl'
import { useButton } from '@react-aria/button'
import { AriaButtonProps } from '@react-types/button'
import SvgIcon from 'components/atoms/SvgIcon'
import ChevronSvg from 'icons/chevron.svg'

export const CalendarButton: FC<AriaButtonProps<'button'>> = (props) => {
  const ref = useRef(null)
  const { buttonProps } = useButton(props, ref)
  return (
    <button { ...buttonProps } ref={ ref } className={ styles.calendarButton }>
      <SvgIcon src={ ChevronSvg } />
    </button>
  )
}
